import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

var obx = observable({
  sessions: [],
  multi: false,
  addSession: false,
  reportIncident: false,
  incidentSession: null,
  incidentSid: null,
  // Get session
  getSession: action(function(accessKey, component, dialogContent) {
    // Check if the session is already being viewed
    let session = obx.sessions.filter(function(key){
      return key.accessKey === accessKey;
    })[0];

    if(typeof session === 'undefined') {
      SessionStore.startLoading('Loading…', 'GetManagerSession');

      api.get(`/sessions/${accessKey}`)
        .then(response => {
          obx.sessions.push(response.data);
          SessionStore.finishLoading('GetManagerSession');

          const {
            installSid,
            courseSid,
            enrollmentSid,
            examConfiguration,
            examSid,
            sid,
            schedulingModule
          } = response.data;

          component.setState({
            installSid,
            courseSid,
            examSid,
            schedulingModule
          })

          obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
          obx.getSessionExam(installSid, courseSid, examSid, sid, null, enrollmentSid, examConfiguration.sid);
        })
        .catch(error => {
          SessionStore.throwError(error);
        })
    } else {
      obx.addSession = false;
      SessionStore.showDialog(dialogContent);
    }
  }),
  // Get the session details
  session: null,
  getExamSession: action(function (installSid, examSid, sessionSid, dialogContent, component, callback) {
    // Check if the session is already being viewed
    let session = obx.sessions.filter(function(key){
      return key.sid === sessionSid;
    })[0];

    if(typeof session === 'undefined') {
      SessionStore.startLoading('Loading…', 'GetManagerExamSession');

      api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`)
        .then(response => {
          obx.sessions.push(response.data);
          obx.session = response.data;

          if(callback) {
            callback();
          }

          // Get enrollment and exam data
          const {
            courseSid,
            enrollmentSid,
            examConfiguration,
            examSid,
            sid
          } = response.data;
          obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
          obx.getSessionExam(installSid, courseSid, examSid, sid, null, enrollmentSid, examConfiguration.sid);

          // Add the courseSid to the parent state so we can use it later
          if(component) {
            component.setState({
              courseSid
            });
          }

          // Finish loading
          SessionStore.finishLoading('GetManagerExamSession');
        })
        .catch(error => {
          SessionStore.throwError(error);
        })
    } else {
      obx.addSession = false;
      SessionStore.showDialog(dialogContent);
    }
  }),
  // Get the session enrollment
  getSessionEnrollment: action(function (installSid, courseSid, enrollmentSid, sessionSid, sessionObj) {
    SessionStore.startLoading('Loading…', 'GetManagerExamEnrollment');

    api.get(`/installs/${installSid}/courses/${courseSid}/enrollments`)
      .then(response => {
        // Filter the response to only the current enrollment
        const enrollment = response.data.results.filter(function(key){
          return key.enrollmentSid === enrollmentSid;
        })[0];

        if(!sessionObj) {
          // Get this session from the array
          let session = obx.sessions.filter(function(key){
            return key.sid === sessionSid;
          })[0];

          // Add the enrollment data to this session
          session.enrollment = enrollment;
        } else {
          sessionObj.enrollment = enrollment;
        }

        // Finish loading
        SessionStore.finishLoading('GetManagerExamEnrollment');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get the session exam data
  getSessionExam: action(function (installSid, courseSid, examSid, sessionSid, sessionObj, enrollmentSid, configurationSid) {
    SessionStore.startLoading('Loading…', 'GetManagerExamData');

    api.get(`/installs/${installSid}/courses/${courseSid}/exams/${examSid}`)
      .then(response => {
        if(!sessionObj) {
          // Get this session from the array
          let session = obx.sessions.filter(function(key){
            return key.sid === sessionSid;
          })[0];

          // Add the exam data to this session
          session.exam = response.data;

          // Get the exam configuration because not all
          // of the data (e.g. exam files) is returned for some reason
          obx.getExamConfiguration(installSid, configurationSid, examSid, sessionSid, sessionObj);
        } else {
          sessionObj.exam = response.data;
        }

        // Finish loading
        SessionStore.finishLoading('GetManagerExamData');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  getExamConfiguration: action((installSid, configurationSid, examSid, sessionSid, sessionObj) => {
    SessionStore.startLoading('Loading…', 'getExamConfiguration');
    api.get(`/installs/${installSid}/examConfigurations/${configurationSid}?examSid=${examSid}`)
      .then(response => {
        if(!sessionObj) {
          // Get this session from the array
          let session = obx.sessions.filter(function(key){
            return key.sid === sessionSid;
          })[0];

          session.exam.configuration = response.data;
          session.examConfiguration = response.data;

          if(response.data.examFiles) {
            session.examFile = response.data.examFiles[0];
          }
        } else {
          sessionObj.exam.configuration = response.data;
          sessionObj.examConfiguration = response.data;

          if(response.data.examFiles) {
            sessionObj.examFile = response.data.examFiles[0];
          }
        }

        SessionStore.finishLoading('getExamConfiguration');
      })
      .catch(error => {
        if(error.response.status !== 404) {
          SessionStore.throwError(error);
        } else {
          SessionStore.finishLoading('getExamConfiguration');
        }
      })
  }),
  // Get written exam file
  getExamFile: action(function(installSid, configurationSid, sessionSid, fileName) {
    SessionStore.startLoading('Loading…', 'getExamFile');

    api.get(`/installs/${installSid}/examConfigurations/${configurationSid}/examFile?sessionSid=${sessionSid}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        const tempLink = document.createElement('a');
        const file = new Blob([response.data], {type: 'application/pdf'});

        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, fileName);
        } else {
          const fileUrl = URL.createObjectURL(file);

          tempLink.href = fileUrl;
          tempLink.download = fileName;
          tempLink.click();

          window.URL.revokeObjectURL(fileUrl);
        }

        SessionStore.finishLoading('getExamFile');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Close a session
  closeExamSession: action(function(sessionSid){
    obx.sessions = obx.sessions.filter(function(key){
      return key.sid !== sessionSid;
    });
  }),
  // Complete a session
  completeExamSession: action(function(installSid, examSid, sessionSid, callback, schedulingModule){
    SessionStore.startLoading('Loading…', 'CloseManagerSession');

    const data = {
      type: schedulingModule,
      reason: 'exam-completed'
    }

    api.post(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/close`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('CloseManagerSession');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get MegaMeeting ID
  getMMId: action(function(installSid, examSid, sessionSid, component, getUrl) {
    SessionStore.startLoading('Loading…', 'GetMMId');

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/meetingRoom`)
      .then(response => {
        if(component) {
          component.setState({
            mmid: response.data.meetId
          });
        }

        SessionStore.finishLoading('GetMMId');

        if(getUrl) {
          obx.getMMUrl(installSid, examSid, sessionSid, component);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get MegaMeeting host url
  getMMUrl: action(function(installSid, examSid, sessionSid, component) {
    SessionStore.startLoading('Loading…', 'GetMMUrl');

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/hostSession`)
      .then(response => {
        if(component) {
          component.setState({
            mmurl: response.data.url
          });
        }

        SessionStore.finishLoading('GetMMUrl');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Cancel session
  cancelExamSession: action(function(installSid, examSid, sessionSid, data, callback){
    SessionStore.startLoading('Loading…', 'cancelExamSession');

    api.delete(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`, { data: data })
      .then(response => {
        SessionStore.finishLoading('cancelExamSession');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Return written files
  returnFiles: [],
  returnExam: action(function(installSid, examSid, sessionSid, callback, session){
    SessionStore.startLoading('Loading…', 'returnExam');

    let formData = new FormData();

    for(let i = 0; i < obx.returnFiles.length; i++) {
      formData.append('returnFiles[]', obx.returnFiles[i]);
    }

    api.put(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/returnFile`, formData)
      .then(response => {
        obx.returnFiles = [];

        session.returnedFile = {
          createdDate: response.data.dateCreated,
          file: response.data.url
        };

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('returnExam');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ManagerStore.js